module.exports = __webpack_public_path__ + "static/media/ladrillo.776bb418.jpg";